'use strict';

var _extends = require('./extends-f8003900.js');
var slicedToArray = require('./slicedToArray-e6d9072a.js');
var React = require('react');
var index = require('./index-0e40e0c2.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var FormContext = /*#__PURE__*/React.createContext({
  validations: {},
  prevStep: function prevStep() {},
  nextStep: function nextStep() {},
  goToStep: function goToStep() {},
  formsValues: {},
  setFormStepValues: function setFormStepValues() {}
});
var useStepControls = function useStepControls() {
  var _useContext = React.useContext(FormContext),
      prevStep = _useContext.prevStep,
      nextStep = _useContext.nextStep,
      goToStep = _useContext.goToStep;

  return {
    prevStep: prevStep,
    nextStep: nextStep,
    goToStep: goToStep
  };
};
var useFormData = function useFormData() {
  var _useContext2 = React.useContext(FormContext),
      formsValues = _useContext2.formsValues,
      setFormStepValues = _useContext2.setFormStepValues;

  return {
    formsValues: formsValues,
    setFormStepValues: setFormStepValues
  };
};
var useFormValidations = function useFormValidations() {
  var _useContext3 = React.useContext(FormContext),
      validations = _useContext3.validations;

  return validations;
};
var FormContextProvider = function FormContextProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;

  var _useState = React.useState({}),
      _useState2 = slicedToArray.slicedToArray(_useState, 2),
      formsValues = _useState2[0],
      setFormValues = _useState2[1];

  function setFormStepValues(values) {
    setFormValues(_extends._extends({}, formsValues, values));
  }

  return /*#__PURE__*/React__default['default'].createElement(FormContext.Provider, {
    value: _extends._extends({}, value, {
      formsValues: formsValues,
      setFormStepValues: setFormStepValues
    })
  }, children);
};
FormContextProvider.propTypes = {
  children: index.PropTypes.node.isRequired,
  value: index.PropTypes.shape({
    formsValues: index.PropTypes.objectOf(index.PropTypes.any),
    gotToStep: index.PropTypes.func,
    nextStep: index.PropTypes.func,
    prevStep: index.PropTypes.func,
    validations: index.PropTypes.objectOf(index.PropTypes.any)
  }).isRequired
};

exports.FormContextProvider = FormContextProvider;
exports.useFormData = useFormData;
exports.useFormValidations = useFormValidations;
exports.useStepControls = useStepControls;
//# sourceMappingURL=FormContext-e45f4589.js.map
